/**
 * Central menu configuration.
 * All nav/tab ordering, visibility rules, and module mappings live here.
 * Change this file to update menus across Sidebar, ProfileNavigation,
 * LiveChatNotification, and Settings simultaneously.
 */

// ─── PLG Rules ───────────────────────────────────────────────────────────────

/** Conversation-level routes hidden for PLG accounts */
export const PLG_HIDDEN_CONVERSATION_ITEMS = [
  "/live-chat",
  "/chat-setup",
  "/installation",
  "/installation-and-integration",
  "/botbuilder",
  "/automation",
  "/trust-hub",
  "/outbound-campaign",
  "/outbound-sms",
];

/** Top-level sidebar section keys removed entirely for PLG accounts */
export const PLG_HIDDEN_SECTION_KEYS = ["workspaces", "review", "marketing"];

/** Settings tab query-param fragments hidden for PLG accounts */
export const PLG_HIDDEN_SETTINGS_TABS = [
  "tab=integration",
  "tab=api-instructions",
  "tab=sensitive",
  "tab=hipaauser",
];


// ─── Conversation Nav ─────────────────────────────────────────────────────────

/**
 * Maps each conversation component path to its module key and PLG-hidden flag.
 * Used by ConversationNavItems to determine visibility without hardcoding logic
 * in the render methods.
 *
 * hiddenForPLG: true  → hide when isPLG
 * module: null        → always visible if the item exists in leftBarAccessList
 */
export const CONVERSATION_ITEM_CONFIG = {
  "/chat-dashboard":      { module: "chat-dashboard",     hiddenForPLG: false },
  "/live-chat":           { module: "livechat",           hiddenForPLG: true  },
  "/completed-chats":     { module: "your_chat",          hiddenForPLG: false },
  "/outbound-campaign":   { module: "outbound-campaign",  hiddenForPLG: true, requiresTwilio: true },
  "/deep-call-analytics": { module: "deep-call-analytics",hiddenForPLG: false, requiresVocera: true },
  "/chat-setup":          { module: "chat_setup",         hiddenForPLG: true  },
  "/botbuilder":          { module: "workspace",          hiddenForPLG: true  },
  "/installation":        { module: "installation",       hiddenForPLG: true  },
};

/** Icons for each conversation component path */
export const CONVERSATION_ITEM_ICONS = {
  "/chat-dashboard":      "fa fa-line-chart",
  "/live-chat":           "fa fa-comment-o",
  "/completed-chats":     "fa fa-check-circle-o",
  "/outbound-campaign":   "fa fa-phone",
  "/deep-call-analytics": "fa fa-bar-chart-o",
  "/chat-setup":          "fa fa-cog",
  "/botbuilder":          "fa fa-building-o",
  "/installation":        "fa fa-file-code-o",
};


// ─── Settings Tabs ────────────────────────────────────────────────────────────

/**
 * Maps each settings tab query-param fragment to its config.
 * Order of tabs on screen is driven by the backend (leftBarAccessList),
 * but visibility/skip rules live here.
 *
 * module:    totalAvailableModules key to check for visibility (null = always show)
 * skipIfPLG: hide this tab for PLG accounts
 * skipIfSubaccount: hide this tab when user_subaccount_id is set
 * stateKey:  key in Settings component state that holds the active CSS class
 * toggleKey: argument passed to Settings.toggleTab()
 */
export const SETTINGS_TAB_CONFIG = {
  "tab=profile":          { module: "profile",          skipIfPLG: false, skipIfSubaccount: false, stateKey: "profileTab",        toggleKey: "profile"       },
  "tab=billing":          { module: "billing",          skipIfPLG: false, skipIfSubaccount: false, stateKey: "billing",           toggleKey: "billing"       },
  "tab=manageuser":       { module: "manage_user",      skipIfPLG: false, skipIfSubaccount: false, stateKey: "userTab",           toggleKey: "user"          },
  "tab=hipaauser":        { module: null,               skipIfPLG: true,  skipIfSubaccount: true,  stateKey: "hipaaUserTab",      toggleKey: "hipaauser"     },
  "tab=sensitive":        { module: "sensitive_data",   skipIfPLG: true,  skipIfSubaccount: false, stateKey: "sensitiveTab",      toggleKey: "sensitive"     },
  "tab=support":          { module: "supportticket",    skipIfPLG: false, skipIfSubaccount: false, stateKey: "supportTab",        toggleKey: "support"       },
  "tab=integration":      { module: "integration",      skipIfPLG: true,  skipIfSubaccount: false, stateKey: "integrationTab",    toggleKey: "integration"   },
  "tab=api-instructions": { module: "api_instructions", skipIfPLG: true,  skipIfSubaccount: false, stateKey: "apiInstructionTab", toggleKey: "apiInstruction"},
};
